/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_TramwayInputs */

const fr_vehicle_type_tramway = /** @type {(inputs: Vehicle_Type_TramwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramway`)
};

const en_vehicle_type_tramway = /** @type {(inputs: Vehicle_Type_TramwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tram`)
};

/**
* | output |
* | --- |
* | "Tram" |
*
* @param {Vehicle_Type_TramwayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_tramway = /** @type {((inputs?: Vehicle_Type_TramwayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_TramwayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_tramway(inputs)
	return en_vehicle_type_tramway(inputs)
});